import { BaseTextFieldProps, InputBaseProps } from "@material-ui/core"
import { Field } from "formik"
import { TextField } from "formik-material-ui"
import styled from "styled-components"

const Styled = {
  Field: styled(Field)<{ $center?: boolean; $hideLabel?: boolean }>`
    ${(p) => p?.$hideLabel && `label { display: none; }`}
    width: 100%;
    .MuiFormHelperText-root {
      font-size: 12px;
    }
    .MuiFormHelperText-root.Mui-error {
      ${(p) => (p.$center ? `text-align: center;` : ``)}
    }
    input {
      color: ${(p) => p.theme.colors.black};
      font-family: "OENaPro";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      ${(p) => (p.$center ? `text-align: center;` : ``)}
    }
  `,
}

export interface CommonInputProps extends BaseTextFieldProps {
  name: string
  label?: string
  onChange: any
  type?: "text" | "email" | "tel" | "number" | "date"
  required?: boolean
  maxLength?: number
  placeholder?: string
  numeric?: boolean
  InputProps?: InputBaseProps
  centerField?: boolean
  autoFocus?: boolean
  className?: string
  hideLabel?: boolean
}

const FormikInput = ({
  name,
  label,
  type = "text",
  required = false,
  placeholder,
  maxLength,
  numeric,
  InputProps,
  centerField,
  autoFocus,
  className,
  hideLabel,
  ...props
}: CommonInputProps) => {
  return (
    <Styled.Field
      $center={centerField}
      $hideLabel={hideLabel}
      label={label}
      component={TextField}
      id={name}
      name={name}
      type={type}
      required={required}
      helperText={" "}
      placeholder={placeholder}
      inputProps={{
        maxLength: maxLength,
        inputMode: numeric && "numeric",
        pattern: numeric && "[0-9]*",
      }}
      InputProps={{
        ...InputProps,
      }}
      autoFocus={autoFocus}
      variant="outlined"
      className={className}
      {...props}
    />
  )
}

export default FormikInput
